module.exports = __webpack_public_path__ + "static/media/energy_entry.65eb2355.svg";